import React from "react";
import CustomTypography from "../typography";
import { AttachmentDocumentType } from "../../../api/commercial/card-application/types";
import {
  CompanyAttachment as CompanyAttachmentDocument,
  PersonAttachment as PersonAttachmentDocument,
} from "../../../api/commercial/generated-types";
import { RequiredDocumentItem } from "../../../pages/document-upload/required-document-item";
import { useMessageSource } from "react-message-source";
import {
  attachmentTypeToDescription,
  deduplicatedPersonAttachments,
} from "../../../util/attachment";

interface RequiredAttachmentListProps {
  listTitle?: string;
  requiredPersonBaaAttachments: PersonAttachmentDocument[];
  requiredPersonCaAttachments: PersonAttachmentDocument[];
  requiredCompanyAttachments: CompanyAttachmentDocument[];
}

export const RequiredAttachmentList = ({
  requiredPersonBaaAttachments,
  requiredPersonCaAttachments,
  requiredCompanyAttachments,
}: RequiredAttachmentListProps): React.JSX.Element => {
  const { getMessageWithNamedParams } = useMessageSource();

  const requiredAttachmentComponents = (
    allAttachments: PersonAttachmentDocument[],
  ) => {
    return allAttachments.map((attOfType, index) => (
      <RequiredDocumentItem
        key={index}
        content={getMessageWithNamedParams(
          attachmentTypeToDescription(
            attOfType.domain as AttachmentDocumentType,
          ),
          {
            firstName: attOfType?.firstName,
            lastName: attOfType?.lastName,
          },
        )}
      />
    ));
  };

  const uniquePersonAttachments = requiredPersonBaaAttachments
    ? deduplicatedPersonAttachments([
        ...requiredPersonCaAttachments,
        ...requiredPersonBaaAttachments,
      ])
    : requiredPersonCaAttachments;

  return (
    <>
      <CustomTypography>
        {requiredCompanyAttachments &&
          requiredAttachmentComponents(requiredCompanyAttachments)}

        {uniquePersonAttachments &&
          requiredAttachmentComponents(uniquePersonAttachments)}
      </CustomTypography>
    </>
  );
};
